/**
 * C2 Púrpura / C2 Mujer — servicio exclusivo mujeres (pasajera + conductora).
 * gender en perfil: 'female' | 'male' | 'other' | null
 * cartype.womenOnly === true (o nombre legacy) activa las reglas.
 */

export const GENDER_FEMALE = 'female';
export const GENDER_MALE = 'male';
export const GENDER_OTHER = 'other';

export const GENDER_VALUES = [GENDER_FEMALE, GENDER_MALE, GENDER_OTHER];

const WOMEN_NAME_RE = /mujer|p[uú]rpura|purpura|women|woman|lady|solo\s*mujeres|exclusivo\s*mujer/i;

export const normalizeGender = (value) => {
  if (value == null || value === '') return null;
  const g = String(value).trim().toLowerCase();
  if (g === 'f' || g === 'femenino' || g === 'femenina' || g === 'mujer' || g === 'female') return GENDER_FEMALE;
  if (g === 'm' || g === 'masculino' || g === 'hombre' || g === 'male') return GENDER_MALE;
  if (g === 'other' || g === 'otro' || g === 'otra' || g === 'no_binario' || g === 'nb') return GENDER_OTHER;
  if (GENDER_VALUES.indexOf(g) !== -1) return g;
  return null;
};

export const isFemaleGender = (value) => normalizeGender(value) === GENDER_FEMALE;

/** Cartype marcado o nombre legacy (C2 Mujer / C2 Purpura). */
export const isWomenOnlyCarType = (carType) => {
  if (!carType) return false;
  if (carType.womenOnly === true) return true;
  const blob = `${carType.name || ''} ${carType.extra_info || ''}`;
  return WOMEN_NAME_RE.test(blob);
};

/** Booking o cartype embebido. */
export const isWomenOnlyService = (bookingOrCar) => {
  if (!bookingOrCar) return false;
  if (bookingOrCar.womenOnly === true) return true;
  if (bookingOrCar.carDetails) return isWomenOnlyCarType(bookingOrCar.carDetails);
  return isWomenOnlyCarType(bookingOrCar);
};

/** Pasajera puede ver/elegir el servicio. */
export const canCustomerSelectWomenOnly = (profile) => isFemaleGender(profile?.gender);

/** Conductora puede asignar cartype womenOnly. */
export const canDriverUseWomenOnlyCarType = (profile, carType) => {
  if (!isWomenOnlyCarType(carType)) return true;
  return isFemaleGender(profile?.gender);
};

/** Lista de cartypes visibles en app según perfil. */
export const filterCarTypesForUser = (cars, profile) => {
  const list = Array.isArray(cars) ? cars : [];
  const female = isFemaleGender(profile?.gender);
  return list.filter((c) => {
    if (c && c.visibleInApp === false) return false;
    if (isWomenOnlyCarType(c) && !female) return false;
    return true;
  });
};

/** Conductor elegible para viaje women-only (perfil público o entry del mapa). */
export const isFemaleDriverEligible = (pubOrDriver) => isFemaleGender(pubOrDriver?.gender);

export const womenOnlyBookingBlockedReason = (profile, carType) => {
  if (!isWomenOnlyCarType(carType)) return null;
  if (!profile?.gender) return 'gender_required';
  if (!isFemaleGender(profile.gender)) return 'women_only_customer';
  return null;
};
